import gql from 'graphql-tag'

export const IMPORT_MODULE = gql`
    mutation importDataModule($input: ImportModuleInput!) {
        importDataModule(input: $input)
    }
`
